import { combineReducers } from "redux";

import stickerItemsReducer from "./sticker-items/reducer";
import stickersReducer from "./stickers/reducer";

export default combineReducers({
  stickerItems: stickerItemsReducer,
  stickers: stickersReducer,
});



// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/entities/reducer.ts